export default "__VITE_ASSET__BBU4$6IH__"